export default "__VITE_ASSET__16c5f4e6__"